import TechnicalAssetsPage from "../../pages/pl/TechnicalAssetsPage";

export default function ClientAssetsTab({ client }) {
  const clientId = String(client?.id || client?._id || "");
  const clientName = client?.bedrijfsnaam || client?.naam || client?.name || "";

  if (!clientId) {
    return (
      <div className="rounded-2xl border border-amber-200 bg-amber-50 p-5 text-sm text-amber-800">
        De klantcontext ontbreekt. Open de Klanthub opnieuw vanuit het klantenoverzicht.
      </div>
    );
  }

  return <TechnicalAssetsPage lockedClientId={clientId} lockedClientName={clientName} />;
}
